/**
 * The organiser the home hero shows: est.28, a gym in Bessbrook, Newry, and
 * their Hybrid Simulation. The dashboard, the athlete's phone, the story card,
 * the wallet pass and the confirmation email all read from here, so they can
 * never disagree about the event.
 *
 * Their brand, venue, event format and theme are theirs, taken from their
 * live event page: navy ground, gold accent with white text on it, Barlow
 * Condensed throughout, transparent content boxes. The 2027 edition, the
 * athletes, prices and figures are invented.
 */

export const ORG = {
  name: 'est.28',
  /** Their gold wordmark, as on their live page header. */
  logo: '/website/brand/logo-est28-trim.png',
  logoAspect: 2642 / 553,
  domain: 'est28.co.uk',
} as const;

export const THEME = {
  /** Page ground (the theme's `primary`). */
  ground: '#132845',
  /** Accent (the theme's `secondary`). */
  accent: '#ECAB35',
  /** Text on the accent. White on their gold, as their live page renders it. */
  onAccent: '#FFFFFF',
  text: '#FFFFFF',
  textMuted: '#D3D9E3',
} as const;

/**
 * est.28's email colours, set the way an organiser sets them (the
 * `emailBranding` override resolveEmailBranding reads first). Without them
 * a dark landing page gets the platform's near-black email palette; these
 * keep their navy.
 */
export const EMAIL_BRANDING = {
  headerBgColor: '#0E1F38',
  bodyBgColor: '#132845',
  cardBgColor: '#1B3558',
  textColor: '#FFFFFF',
  textMutedColor: '#A9B6CA',
} as const;

export const EVENT = {
  name: 'EST.28 Hybrid Simulation 2027',
  /** 8:30am on Saturday 11 September 2027, Europe/London (BST). */
  start: new Date('2027-09-11T07:30:00Z'),
  timezone: 'Europe/London',
  dateLong: 'Saturday 11 September 2027',
  dateShort: 'Sat 11 Sep',
  dayMonth: '11 Sep',
  time: '8:30 A.M.',
  venue: 'est.28, 2 Crabtree Hill, Bessbrook, Newry BT35 6JY, UK',
  venueShort: 'Bessbrook, Newry',
  activityType: 'hybrid',
  activityLabel: 'Hybrid',
  nature: 'Competitive',
  about:
    'Join us for the EST.28 Hybrid Simulation on 11th September 2027 at Crabtree Hill in Bessbrook, Newry. Eight runs, eight functional stations, judged against the clock, in singles, pairs and relay.',
} as const;

export const TICKETS = [
  { key: 'singles', name: 'Singles', price: '£80', remaining: '9/40 remaining' },
  { key: 'pairs', name: 'Pairs', price: '£150', remaining: '5/30 remaining', perTeam: true },
  { key: 'relay', name: 'Relay (team of 4)', price: '£260', perTeam: true },
] as const;

/** The pair who enter in the loop. Invented. */
export const ATHLETE = {
  name: 'Maria Kelleher',
  firstName: 'Maria',
  initials: 'MK',
  partner: 'Aoife Rice',
  partnerEmail: 'aoife.rice@example.com',
  email: 'maria.kelleher@example.com',
  division: "Women's Pairs",
  ticket: 'Pairs',
  total: '£157.05',
  totalPence: 15705,
  orderReference: 'FV-20270611-K7Q2LX',
  ticketReference: 'ETS2027-7K2LQX',
} as const;
